<div class="card card-with-no-padding mt-4">
    <div class="card-head pr-0 mt-3">
        <div class="row w-100 padding-left align-items-center">
            <div class="col-10 pl-1">
                <div class="title font-24 fontSemiBold">{{'restaurant.Cancellation & Refund Policies' | translate}}
                    <span class="pl-1 grey-color fontRegular" *ngIf="recordsData?.cancellationPolicies?.pageData?.length">({{recordsData?.cancellationPolicies?.totalCount}})</span>
                </div>
            </div>
            <div class="col-2 text-right pl-auto pr-0"
                *ngIf="canAddCancellationPolicy">
                <button type="button" class="btn btn-with-icon" (click)="addCancellationPolicy()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="card-content mt-3" *ngIf='!dataLoading'>
        <div>
            <div class="table-responsive table-container table-no-borders"
                *ngIf="recordsData?.cancellationPolicies?.pageData && recordsData?.cancellationPolicies?.pageData?.length; else dataEmpty">
                <table class="table table-primary table-hover no-background">
                    <thead>
                        <tr>
                            <th>{{'restaurant.Policy Title' | translate}}</th>
                            <th>{{'restaurant.Refund Amount' | translate}}</th>
                            <th>{{'restaurant.Before Booked Reservation Time by' | translate}}</th>
                            <!-- <th>{{'restaurant.After Guest Submit Reservation by' | translate}}</th> -->
                            <th></th>
                        </tr>

                    </thead>
                    <tbody>
                        <tr *ngFor="let item of recordsData?.cancellationPolicies?.pageData">
                            <td class="fontMedium">{{item.name}}</td>
                            <td class="fontMedium">{{item.refundAmount}}%</td>
                            <td class="fontMedium">{{item.beforeReservation}}</td>
                            <!-- <td class="fontMedium">{{item.afterReservation}}</td> -->
                            <td>
                                <div class="btn-actions">
                                    <button type="button" mat-icon-button *ngIf="item.isActive && canEditCancellationPolicy"
                                        (click)="changeCancellationPolicyStatus(item.id, false)"
                                        [matTooltip]="'general.Deactivate' | translate">
                                        <mat-icon>pause</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button *ngIf="!item.isActive && canEditCancellationPolicy"
                                        (click)="changeCancellationPolicyStatus(item.id, true)"
                                        [matTooltip]="'general.Activate' | translate">
                                        <mat-icon>play_arrow</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                        (click)="addCancellationPolicy(item.id)" *ngIf="canEditCancellationPolicy">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Delete' | translate"
                                        (click)="deleteCancellationRecord(item.id)" *ngIf="canDeleteCancellationPolicy">
                                        <mat-icon class="delete-icon">delete</mat-icon>
                                    </button>

                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <div class="mb-4">
              <app-paging
                  [pageIndex]="pageIndex"
                  [pageCount]="pageCount"
                  [maxPages]="6"
                  (page)="getAllCancellation($event)"
              ></app-paging>
            </div>

            <hr class="mt-0">

            <div class="title font-16 pl-3 fontMedium">
                {{'restaurant.No-Show Policy' | translate}}
                <p class="info ml-1 mt-3">
                    {{"restaurant.This policy will be applied once the restaurants host or those who have his permission take a reservation with a No Show action" | translate}}
                </p>
            </div>

            <div class="grey-list-items form-group">
                <div class="list-item pl-3 mt-1">
                    <div class="d-flex align-items-center">
                        <p class="font-14">{{'restaurant.Refund Amount' | translate }}: </p> <span
                            class="font-14 ml-3 fontMedium">{{policyAmount + '%'}}</span>
                    </div>
                    <div>
                        <div class="btn-actions">
                          <ng-container *ngIf="recordsData?.noShowPolicies">
                            <button type="button" mat-icon-button *ngIf="recordsData?.noShowPolicies?.isActive && canEditCancellationPolicy"
                              (click)="changeShowPolicyStatus(0, false)"
                              [matTooltip]="'general.Deactivate' | translate">
                              <mat-icon>pause</mat-icon>
                            </button>
                            <button type="button" mat-icon-button *ngIf="!recordsData?.noShowPolicies?.isActive && canEditCancellationPolicy"
                                (click)="changeShowPolicyStatus(0, true)"
                                [matTooltip]="'general.Activate' | translate">
                                <mat-icon>play_arrow</mat-icon>
                            </button>
                          </ng-container>
                          <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                              (click)="editShowPolicy(policyAmount)" *ngIf="canEditCancellationPolicy">
                              <mat-icon>edit</mat-icon>
                          </button>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="title font-16 pl-3 fontMedium">
                {{'restaurant.Exceptions' | translate}}
                <p class="info ml-1 mt-3">
                    {{"restaurant.Exceptions mean that certain guests are not charged cancellation fees and are fully refunded" | translate}}
                </p>
            </div>
            <div class="grey-list-items form-group">
                <div class="list-item pl-3 mt-1 mb-0 pb-0">
                    <div class="d-flex align-items-center">
                        <p class="font-14">{{'restaurant.Guests who booked this no. of reservations (all the time)'
                            | translate }}: </p> <span
                            class="font-14 ml-3 fontMedium">{{exceptionReservationNumber?.reservationNumber}}</span>
                    </div>
                    <div>
                        <div class="btn-actions">
                            <button type="button" mat-icon-button *ngIf="recordsData?.exception?.isActive && canEditCancellationPolicy"
                                (click)="changeExceptionReservationStatus(false)"
                                [matTooltip]="'general.Deactivate' | translate">
                                <mat-icon>pause</mat-icon>
                            </button>
                            <button type="button" mat-icon-button *ngIf="!recordsData?.exception?.isActive && canEditCancellationPolicy"
                                (click)="changeExceptionReservationStatus(true)"
                                [matTooltip]="'general.Activate' | translate">
                                <mat-icon>play_arrow</mat-icon>
                            </button>
                            <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                (click)="exceptionRuleForReservation(exceptionReservationNumber?.reservationNumber)"
                                *ngIf="canEditCancellationPolicy">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="list-item pl-3 mt-1 pt-0">
                    <div class="d-flex align-items-center">
                        <p class="font-14 pr-3">{{'restaurant.Guests who got these tags' | translate }}: </p>
                        <ng-container *ngIf="exceptionTags">
                            <span *ngFor="let selectedTag of exceptionTags.selectedTags; let last = last">
                                <ng-container *ngFor="let tag of exceptionTags.allTags">
                                    <span class="font-14 fontMedium" *ngIf="selectedTag == tag.id">{{tag.name}}<span
                                            *ngIf="!last">,
                                        </span>
                                    </span>
                                </ng-container>
                            </span>
                        </ng-container>
                    </div>
                    <div>
                        <div class="btn-actions">
                            <button type="button" mat-icon-button
                                *ngIf="exceptionTags?.selectedTags && recordsData?.exceptionTags?.isActive && canEditCancellationPolicy"
                                (click)="changeExceptionTagStatus(false)"
                                [matTooltip]="'general.Deactivate' | translate">
                                <mat-icon>pause</mat-icon>
                            </button>
                            <button type="button" mat-icon-button
                                *ngIf="exceptionTags?.selectedTags && !recordsData?.exceptionTags?.isActive && canEditCancellationPolicy"
                                (click)="changeExceptionTagStatus(true)" [matTooltip]="'general.Activate' | translate">
                                <mat-icon>play_arrow</mat-icon>
                            </button>
                            <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                (click)="exceptionRuleForGuestsTags()" *ngIf="canEditCancellationPolicy">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <div *ngIf='dataLoading' class="dataLoading py-5">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <ng-template #dataEmpty>
        <empty-state [title]='"restaurant.Cancellation and refund policies not yet added" | translate'
            [img]="'/assets/images/icons/cancellation_refund_illustration.svg'"></empty-state>
        <a class="btn-light mt-1" mat-stroked-button (click)="addCancellationPolicy()" *ngIf="canAddCancellationPolicy">
            {{'restaurant.Add new Cancellation Policy' | translate}}</a>
    </ng-template>
</div>
